import React, { Fragment } from "react";
import PageError from "./PageError";
import uiUtils from "./uiUtils";
import simpleUtils from "../simpleUtils";

const FormErrors = (props) => {
  const { errors, uiSchema_nav, uiSchema_lookup } = props;
  let all_errors = simpleUtils.parseMachineNameForObjectBuilding(
    errors,
    uiSchema_nav,
    uiSchema_lookup
  );

  return (
    <div>
      {uiSchema_nav.map((navItem, index) => {
        let errors_for_page = all_errors.filter(
          (e) => parseInt(e.page_index) === index
        );
        let error_count = errors_for_page.length;
        let prefix = navItem.prefix && uiUtils.removeLineBreak(navItem.prefix);
        let page_name = navItem.name && uiUtils.removeLineBreak(navItem.name);
        return (
          <Fragment key={index}>
            {error_count !== 0 && (
              <PageError>
                <strong>
                  {prefix && <span>{`${prefix}: `}</span>}{" "}
                  {page_name && <span>{`${page_name}`}</span>}
                </strong>
                <br />
                <em>
                  There {uiUtils.isOrAre(error_count)} {error_count}{" "}
                  {uiUtils.pluralS(error_count, "error")} on this page
                </em>
                {errors_for_page.map((err, i) => {
                  let { value: message, code } = err;
                  // renderErrorMessage handles field and fieldArray types
                  return uiUtils.renderErrorMessage(code, message);
                })}
              </PageError>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default FormErrors;
